import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, TrendingUp } from "lucide-react";
import { api, usePoll } from "@/lib/api";
import { useTour } from "@/components/tour/TourProvider";
import { TierBadge } from "@/components/funding/TierBadge";

export function TopIndustries() {
  const [d, setD] = useState(null);
  const es = useTour().lang === "es";
  const load = useCallback(() => api.get("/funding/top-industries", { params: { lang: es ? "es" : "" } }).then((r) => setD(r.data)).catch(() => {}), [es]);
  useEffect(() => { load(); }, [load]);
  usePoll(load, !!d?.translating, 5000);
  if (!d) return <Loader2 className="h-5 w-5 animate-spin text-emerald-600" />;
  return (
    <div data-testid="top-industries">
      <p className="text-sm text-slate-600 max-w-3xl">Industries receiving the most small business and nonprofit grant money right now, across federal, state, county and city programs. <span>Refreshed monthly</span>{d.updated_at ? ` · last updated ${new Date(d.updated_at).toLocaleDateString()}` : ""}. <span>AI-researched, so always confirm with the program.</span></p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {d.items.map((it, i) => (
          <div key={i} className="card-lift bg-white border border-slate-200 rounded-lg p-5" data-testid={`top-industry-${i}`}>
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-semibold text-slate-900"><span className="font-mono text-emerald-600 mr-2">{String(i + 1).padStart(2, "0")}</span><Link to={`/grants-for/${it.slug}`} className="hover:text-emerald-700 hover:underline underline-offset-4" data-testid={`top-industry-${i}-link`}>{it.name}</Link></h3>
              <TrendingUp className="h-4 w-4 text-emerald-600 shrink-0" />
            </div>
            <div className="mt-2 flex flex-wrap gap-1">{(it.levels || []).map((l) => <TierBadge key={l} tier={l} />)}</div>
            <p className="text-sm text-slate-600 mt-3">{it.why}</p>
            <ul className="mt-3 space-y-1 text-xs text-slate-500 list-disc pl-4">{(it.examples || []).map((e) => <li key={e}>{e}</li>)}</ul>
            <p className="mt-3 text-xs"><span className="font-mono uppercase text-slate-400 mr-1">Typical award</span><span className="font-semibold text-slate-800">{it.typical_award}</span></p>
          </div>
        ))}
      </div>
    </div>
  );
}
